"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.web3ConnectorFactory = exports.createWeb3OfflineConnectorHelper = void 0;
const Errors_1 = require("../Errors");
const _1 = require(".");
const createWeb3OfflineConnectorHelper = (name, jsonRpcUrl) => (config) => new _1.Web3BaseConnector(jsonRpcUrl, {
    name,
    displayName: name,
    isWallet: false,
}, config);
exports.createWeb3OfflineConnectorHelper = createWeb3OfflineConnectorHelper;
const web3ConnectorFactory = (config, metadata, { jsonRpcUrl }) => {
    if (metadata.isWallet) {
        throw new Errors_1.WalletFactoryNotImplemented(config.blockchain);
    }
    return new _1.Web3BaseConnector(jsonRpcUrl, metadata, config);
};
exports.web3ConnectorFactory = web3ConnectorFactory;
